export var getWindow = function getWindow() {
  if (typeof window === 'undefined') return undefined;
  return window;
};
export var getIsDecoupled = function getIsDecoupled() {
  // @ts-expect-error webpack replace
  return typeof IS_DECOUPLED_WEBPACK !== 'undefined' && !!IS_DECOUPLED_WEBPACK;
};
export var getPortalContainer = function getPortalContainer() {
  var host = document.querySelector('topup-component');
  var shadowRoot = host === null || host === void 0 ? void 0 : host.shadowRoot;
  if (getIsDecoupled()) {
    if (!shadowRoot) throw new Error('no shadow root');
    return shadowRoot;
  }
  return document.body;
};
export {};